import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import _ from 'lodash';
import styled from 'styled-components';

import { Button } from '../../../components/Buttons';
import { HBox, VBox } from '../../../components/Box';
import { PageHeader } from '../../../components/PageHeader';
import { Left } from '../../../components/Icon';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { Loader } from '../../../components/Loader';

import { VehicleInvoiceCard } from '../components/IncomingInvoice/CardVehicleInfo';
import { CreditorInfoCard } from '../components/IncomingInvoice/CreditorInfoCard';
import { InvoiceSubjectsCard } from '../components/IncomingInvoice/CardInvoiceSubjects';
import { VehicleDocumentCard } from '../components/IncomingInvoice/CardVehicleDoc';
import { PdfViewerCard } from '../components/IncomingInvoice/CardPdfViewer';
import { LedgersPosting } from '../components/Ledgers/LedgersPosting';
import { InvoicePurchaseInfoCard } from '../components/IncomingInvoice/CardPurchaseInfo';
import { CompanyDocumentsCard } from '../../Companies/components/CardDocuments';
import { CreditInvoiceModal } from '../components/CreditInvoiceModal';
import { DeleteInvoiceModal } from '../components/DeleteInvoiceModal';
import { InvoiceQuizModal } from '../components/InvoiceQuizModal';
import { ViesCheckPrompt } from '../components/ViesCheckPrompt';
import { InvoiceFinalizationStatusBar } from '../components/InvoiceFinalizationStatusBar';
import { Permission } from '../../../components/Permission';
import {
  addInvoiceSubject,
  addRelationSource,
  createCreditInvoice,
  declineInvoice,
  deleteInvoice,
  fetchInvoice,
  finalizeAndExportInvoice,
  finalizeV2,
  getExactAuthStatus,
  initiateInvoiceEdit,
  initiateNewInvoiceValue,
  removeInvoiceSubject,
  removeRelationSource,
  retryFinalizationV2,
  setNewInvoiceValue,
  updateInvoiceStatus,
  updateInvoiceSubject,
  updateInvoiceV2,
  getCurrentRestBpm,
  getVatCodes, exportInvoiceToExact,
} from '../actions';
import {calculatePurchasePriceInclVatExclBPM, setVehicleProperties} from '../../Vehicles/actions';
import { addApiError } from '../../Api/actions';
import { checkVies, fetchCompany } from '../../Companies/actions';

import { selectInvoice, selectAutotelexBPM, selectNewInvoice } from '../selectors';
import { selectWork, selectWorks } from '../../Api/selectors';

import {
  INVOICE_DIRECTIONS,
  REQUEST_CREATE_CREDIT_INVOICE,
  REQUEST_EXACT_AUTH_STATUS,
  REQUEST_EXACT_EXPORT_INVOICE,
  REQUEST_INVOICE,
  REQUEST_INVOICE_DECLINE,
  REQUEST_INVOICE_DELETE,
  REQUEST_SYNC_BPM,
  INVOICE_SUBJECT_TYPES,
  REQUEST_UPDATE_INVOICE_V2,
  INVOICE_TYPES,
  FINALIZE_EXPORT_MAIL_INVOICE,
  FINALIZATION_STATUSES,
} from '../constants';
import {
  CALCULATE_PURCHASE_PRICES_BTW,
  CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM,
  CALCULATE_PURCHASE_PRICES_MARGE, VEHICLE_PURPOSE, VEHICLE_TAX_TYPE,
} from '../../Vehicles/constants';
import { REQUEST_COMPANY, REQUEST_VIES_CHECK } from '../../Companies/constants';
import { INVOICE_EDIT, VEHICLE_EXTRA_COSTS_CRUD, PURCHASING_DATA_CRUD } from '../../../components/Permission/constants';
import { getFinalizationStatus } from '../helpers';

import { FormField } from '../../../components/FormFields';
import LoadingDetailsPage from '../../../containers/App/Components/LoadingDetailsPage/LoadingDetailsPage';
import { LoadingWithNotification } from '../../../components/LoadingWithNotification/LoadingWithNotification';
import { InvoiceCreateCopyModals } from './createIncomingCopy/AddIncomingInvoiceCopy';
import { INCOMING_CREDIT_LIMIT_NOT_ENOUGH } from '../../../utils/request';
import { Modal, ModalControls } from '../../../components/Modal';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import {fixPriceFormat} from "../../../utils/string";

const Container = styled.div`
display: grid;
  gap: 16px; /* Adjust spacing between columns */


  grid-template-columns: 33% 33% 33%;

  @media (max-width: 1024px) {
    grid-template-columns: 48% 48%;
  }

  @media (max-width: 768px) {
    grid-template-columns: 100%;
  }

  @media (max-width: 1024px) {
    justify-content: center; /* Center columns on medium screens */
  }


  }
`;

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 24px;
  color: red;
`;

const STATE = {
  requireField: [],
  showCreditModal: false,
  newSubjects: [],
  showQuizCredit: false,
  showQuizDelete: false,

  showViesCheckPrompt: false,
};

const FINALIZE_REQUIRE_FIELDS = [
  'buying_contact',
  'customernumber',
  'referenceNumber',
  'vehiclePurpose',
  'btwOrMarge',
  'date',
  'financialTotalAmount',
  'company_from_eu',
];

const VEHICLE_PROPS = ['regplate', 'vin', 'mileage', 'date_first_allowance', 'new_from_factory', 'import', 'buying_contact'];
const INVOICE_PROPS = ['financialTotalAmount'];
const BUYING_COMPANY_PROPS = ['financial_contact', 'company_from_eu', 'BTW_number', 'IBAN', 'customernumber'];
const PURCHASE_PROPS = [
  'buyingCompany',
  'referenceNumber',
  'date',
  'vehicle_purpose',
  'btwOrMarge',
  'financial_purchase_price_excl_vat_excl_bpm',
  'rest_bpm',
  'financial_bpm_gross',
  'vatCode',
  'vat_amount',
  'financial_purchase_price_incl_vat_bpm',
  'financial_purchase_price_marge_bpm',
  'financial_purchase_price_marge_excl_bpm',
  'paidDate',
  'entryNumber',
];

/* eslint-disable react/prefer-stateless-function */
class IncomingInvoiceDetailsComp extends BaseComponent {
  constructor(props) {
    super(props, { ..._.cloneDeep(STATE) });
    this.goBack = this.goBack.bind(this);
  }

  goBack(event) {
    window.history.go(-1);
  }

  componentDidMount() {
    this.props.fetchInvoice();
    this.props.getCode();
    if (this.props.match.params?.id != this.props.values?.id) {
      this.props.init(this.props.match.params?.id);
    }
    this.props.initiateValues([...VEHICLE_PROPS, ...INVOICE_PROPS, ...BUYING_COMPANY_PROPS, ...PURCHASE_PROPS]);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps?.invoice?.invoiceSubjects?.filter(sub => sub.type === INVOICE_SUBJECT_TYPES.COST).length &&
      prevProps?.invoice?.invoiceSubjects?.filter(sub => sub.type === INVOICE_SUBJECT_TYPES.COST).length !==
        this.invoice?.invoiceSubjects?.filter(sub => sub.type === INVOICE_SUBJECT_TYPES.COST).length
    ) {
      this.onUpdate();
    }

    if (
      this.props.values?.btwOrMarge != prevProps.values?.btwOrMarge ||
      this.props.values?.import != prevProps.values?.import ||
      this.props.values?.vehiclePurpose != prevProps.values?.vehiclePurpose
    ) {
      this.setState({ requireField: [], showPrompt: false });
    }
  }

  getFieldValue(fieldName) {
    if (Object.keys(this.state).includes(fieldName)) {
      return this.state[fieldName];
    }
    return this.props.invoice[fieldName];
  }

  get invoice() {
    return this.props.invoice;
  }

  get vehicleSubject() {
    return this.invoice?.invoiceSubjects?.filter(sub => sub.type === INVOICE_SUBJECT_TYPES.VEHICLE);
  }

  get noVehicleSubjects() {
    const invoiceSubjects = this.props.invoice?.invoiceSubjects.filter(
      subject => subject.type !== INVOICE_SUBJECT_TYPES.VEHICLE,
    );

    return invoiceSubjects;
  }

  get extraSubjects() {
    return this.invoice?.invoiceSubjects?.filter(sub => sub.type === INVOICE_SUBJECT_TYPES.COST);
  }

  get extraTotalAmount() {
    let price = this.state.newSubjects.reduce((acc, current) => {
      return acc + current.price;
    }, 0);
    return price;
  }

  get vehicleSubjectPrice() {
    const price = this.vehicleSubject[0]?.price;
    return price;
  }

  get dto() {
    let isFinal = this.props.invoice?.isFinal;
    const referenceNumber = this.props.values?.referenceNumber;
    const date = this.props.values?.date;
    const direction = this.props.invoice?.direction;
    const importValue = this.props.values?.import === true || this.props.values?.import == '1' ? '1' : '0';
    let isUpdateSubjects = false;

    if (direction === INVOICE_DIRECTIONS.INCOMING && !referenceNumber) {
      isFinal = false;
    }

    let dto = {
      desiredDeliveryDate: null,
      dueDate: null,
      economicalTotalAmount: null,
      payments: null,
      incoming: null,
      isFinal,
      direction,
      referenceNumber,
      date,

      vehicle: {},
      company: {},
      invoiceSubjects: [this.vehicleSubject[0], ...this.noVehicleSubjects],
    };

    [...VEHICLE_PROPS, 'vehiclePurpose'].map(prop => {
      if (prop == 'import' || prop == 'new_from_factory') {
        let invoiceValue = this.props.invoice?.vehicle[prop];
        let changedValue = this.props.values[prop] == '1' || this.props.values[prop] === true;
        if (invoiceValue !== changedValue) {
          const value = changedValue ? '1' : '0';
          dto.vehicle[prop] = value;
        }
        return;
      }
      if (this.props.values[prop] !== this.props.invoice?.vehicle[prop]) {
        if (prop == 'vehiclePurpose') {
          dto.vehicle.vehicle_purpose = this.props.values[prop];
          return;
        }

        dto.vehicle[prop] = this.props.values[prop] || null;
      }
    });

    ['BTW_number', 'IBAN', 'customernumber'].map(prop => {
      if (this.props.values[prop] !== this.props.invoice?.incomingCompany[prop]) {
        dto.company[prop] = this.props.values[prop] || null;
        return;
      }
    });

    ['date', 'paidDate'].map(prop => {
      if (this.props.values[prop] !== this.props.invoice[prop]) {
        dto[prop] = this.props.values[prop];
      }
    });

    [
      'financial_purchase_price_incl_vat_bpm',
      'financial_purchase_price_incl_vat_excl_bpm',
      'financial_purchase_price_excl_vat_excl_bpm',
      'financial_bpm_gross',
      'financial_purchase_price_marge_bpm',
      'financial_purchase_price_marge_excl_bpm',
      'rest_bpm',
    ].map(prop => {
      if (this.vehicleSubject?.[0] && this.props.values?.[prop] !== this.vehicleSubject?.[0]?.[prop]) {
        isUpdateSubjects = true;
      }
      return;
    });

    let subjectForUpdate = [
      {
        id: this.vehicleSubject[0]?.id,
        description: this.vehicleSubject[0]?.description,
        invoiceId: +this.props.invoice_id,
        price: this.parseAmount(this.props.values?.financial_purchase_price_incl_vat_excl_bpm || 0),
        economicalPrice: null,
        type: 'vehicle',
        vehicleId: this.vehicleSubject[0]?.vehicleId,
        discount: this.parseAmount(this.vehicleSubject[0]?.discount),
        btwOrMarge: this.props.values?.btwOrMarge,
        rest_bpm: this.parseAmount(this.props.values?.rest_bpm),
        financial_purchase_price_incl_vat_bpm: this.parseAmount(this.props.values?.financial_purchase_price_incl_vat_bpm),
        financial_purchase_price_incl_vat_excl_bpm: this.parseAmount(
          this.props.values?.financial_purchase_price_incl_vat_excl_bpm,
        ),
        financial_purchase_price_excl_vat_excl_bpm: this.parseAmount(
          this.props.values?.financial_purchase_price_excl_vat_excl_bpm,
        ),
        financial_bpm_gross: this.parseAmount(this.props.values?.financial_bpm_gross),
        financial_purchase_price_marge_bpm: this.parseAmount(this.props.values?.financial_purchase_price_marge_bpm),
        financial_purchase_price_marge_excl_bpm: this.parseAmount(
          this.props.values?.financial_purchase_price_marge_excl_bpm,
        ),
        subjectVat: {
          id: this.vehicleSubject[0]?.subjectVat?.id,
          amount: this.parseAmount(this.props.values?.vat_amount),
          code: this.props.values?.vatCode,
          baseAmount: this.parseAmount(this.vehicleSubject[0]?.subjectVat?.baseAmount),
          subjectId: this.vehicleSubject[0]?.id,
        },
      },
      ...this.noVehicleSubjects,
    ];
    if (isUpdateSubjects) {
      dto.invoiceSubjects = subjectForUpdate;
    }

    return dto;
  }

  parseAmount(raw) {
    if (raw === null) return null;
    if (raw === undefined) return null;
    if (Math.sign(+raw) === -1) return null;
    return typeof raw == 'string' ? parseFloat(raw?.replace(',', '.')) : +raw;
  }

  getColumnTypes() {
    let types = [];

    // DEPENDS ON TAX_TYPE, IMPORT AND VEHICLE_PURPOSE
    const isImported = this.props?.invoice?.import;
    if (
      this.props.values?.btwOrMarge === 'marge' &&
      (isImported === '1' || isImported === true)
    ) {
      return types.concat(...['financial_purchase_price_marge_excl_bpm']);
    }

    if (
      this.props.values?.btwOrMarge === 'BTW' &&
      (isImported === '1' || isImported === true)
    ) {
      return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
    }

    if (
      (isImported === '0' || isImported === false) &&
      this.props.values?.vehiclePurpose === 'passenger' &&
      this.props.values?.btwOrMarge === 'marge'
    ) {
      return types.concat(...['financial_purchase_price_marge_bpm']);
    }

    if (
      (isImported === '0' || isImported === false) &&
      this.props.values?.vehiclePurpose === 'commercial' &&
      this.props.values?.btwOrMarge === 'marge'
    ) {
      return types.concat(...['financial_purchase_price_marge_bpm']);
    }

    if (
      (isImported === '0' || isImported === false) &&
      this.props.values?.vehiclePurpose === 'passenger' &&
      this.props.values?.btwOrMarge === 'BTW'
    ) {
      return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_bpm']);
    }

    if (
      (isImported === '0' || isImported === false) &&
      this.props.values?.vehiclePurpose === 'commercial' &&
      this.props.values?.btwOrMarge === 'BTW'
    ) {
      return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
    }

    // DEPENDS ON TAX_TYPE AND IMPORT

    return types;
  }

  getSubject(subject) {
    let subjects = this.state.newSubjects.filter(subj => subj.id !== subject.id);
    this.setState(prev => {
      return {
        ...prev,
        newSubjects: [...subjects, subject],
      };
    });
  }

  onUpdate() {
    this.props.update(this.dto, result => {
      if (result?.id) {
        this.setState({ ...STATE });
      }
    });
  }

  showCreditModal = () => {
    this.setState({ showCreditModal: true });
  };

  showCreditAndCopyModal = () => {
    this.setState({ showCreditModal: true, copyAfterCredit: true });
  };

  renderCreditModal() {
    return (
      this.state.showCreditModal && (
        <CreditInvoiceModal
          onConfirm={this.onConfirmCreditModal.bind(this)}
          onCancel={this.onCancelCreditModal.bind(this)}
        />
      )
    );
  }

  onConfirmDeleteModal() {
    this.setState({ showDeleteModal: false, showQuizDelete: true });
  }

  onCancelDeleteModal() {
    this.setState({ showDeleteModal: false });
  }

  renderDeleteModal() {
    return (
      this.state.showDeleteModal && (
        <DeleteInvoiceModal
          onConfirm={this.onConfirmDeleteModal.bind(this)}
          onCancel={this.onCancelDeleteModal.bind(this)}
        />
      )
    );
  }

  redirectAfterDelete = () => {
    if (this.invoice?.vehicle?.id) {
      return this.to(`/vehicles/${this.invoice?.vehicle?.id}`);
    } else {
      return this.to(`/invoices`);
    }
  };

  onConfirmCreditModal() {
    this.setState({ showQuizCredit: true, showCreditModal: false });
  }

  onCancelCreditModal() {
    this.setState({ showCreditModal: false, copyAfterCredit: false });
  }

  reset() {
    this.setState({ showViesCheckPrompt: false });
  }

  get requireFields() {
    let secondary = this.getColumnTypes();
    let types = [...FINALIZE_REQUIRE_FIELDS, ...secondary].filter(type => {
      return !this.props.values[type];
    });

    return types;
  }

  get exportedAtMsg() {
    // Show old message if an invoice has been exported with an old flow
    if (this.props.invoice.exportedAt && !this.invoice.finalizationStatus) {
      return (
        <p>
          {this.lbl('invoice.details.exportedStatus')} {this.invoice.exportedAt}
        </p>
      );
    }

    return <InvoiceFinalizationStatusBar invoice={this.invoice} />;
  }

  onViesCheck() {
    const dto = {
      id: this.invoice?.incomingCompanyId,
      entity: 'company',
      countryCode: this.props.values?.BTW_number?.substring(0, 2),
      vatCode: this.props.values?.BTW_number?.substring(2),
    };
    this.props.checkViesStatus(dto, result => {
      if (result?.valid) {
        this.finalize();
        this.setState(prev => {
          return {
            lastViesChecking: !prev.lastViesChecking,
          };
        });
        return;
      }

      this.setState(prev => {
        return {
          showViesCheckPrompt: true,
          lastViesChecking: !prev.lastViesChecking,
        };
      });
    });
  }

  finalize(options) {
    this.setState({ showViesCheckPrompt: false });
    if (this.requireFields.length) {
      return this.setState({ requireField: this.requireFields, showPrompt: true });
    }
    this.setState({ requireField: [], showPrompt: false });

    return this.props.update(this.dto, result => {
      if (result?.id) {
        this.setState({ ...STATE });
        this.props.finalizeAndExport('incoming', '', result => {
          console.log(result, 'RESULT');
        });
      }
    });

    // return this.props.finalizeAndExport('incoming', '', result => {
    //   console.log(result, 'RESULT');
    // });
  }

  finalizeV2() {
    return this.props.update(this.dto, result => {
      if (result?.id) {
        this.setState({ ...STATE });
        this.props.finalizeV2({}, res => {
          if (res?.message === INCOMING_CREDIT_LIMIT_NOT_ENOUGH) {
            this.setState({ creditLimitWarning: true });
          }
        });
      }
    });
  }

  cancelCreditLimitModal() {
    this.setState({ creditLimitWarning: false });
  }

  applyCreditLimitModal() {
    this.props.finalizeV2({ skipCreditLimitCheck: true }, () => {
      this.setState({ creditLimitWarning: false });
    });
  }

  renderCreditLimitWarningModal() {
    if (!this.state.creditLimitWarning) return '';

    return (
      <Modal onClose={this.cancelCreditLimitModal.bind(this)} title={this.lbl('invoice.credit_limit_exceeded')}>
        <ModalControls>
          <Button isPrimary onClick={this.applyCreditLimitModal.bind(this)}>
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.cancelCreditLimitModal.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderFinalizeBtn() {
    const finalize = () => {
      if (!+this.props.values?.financialTotalAmount) {
        return this.setState({ showNonTotalAmountNotification: true });
      }

      if (!this.invoice?.vehicle?.regplate && !this.invoice?.vehicle?.import && this.state.acceptNonImport !== 'yes') {
        this.setState({ showNonImportNotification: true });
        return;
      }
      this.finalizeV2();
    };
    if (this.state.showNonImportNotification) {
      return (
        <ModalComponent onClose={() => this.setState({ showNonImportNotification: false, acceptNonImport: null })}>
          <strong>{this.lbl('invoice.overview.non_import_notification')}</strong>

          <div className="d-flex gap-2 mt-2">
            <ButtonComponent
              style="ButtonSoftEdit"
              onClick={() => this.setState({ acceptNonImport: 'yes', showNonImportNotification: false }, () => finalize())}
            >
              {this.lbl('yes')}
            </ButtonComponent>
            <ButtonComponent
              style="ButtonSoftDelete"
              onClick={() => this.setState({ showNonImportNotification: false, acceptNonImport: null })}
            >
              {this.lbl('cancel')}
            </ButtonComponent>
          </div>
        </ModalComponent>
      );
    }

    // Show old button if invoice has been finalized with an old flow
    if (this.invoice.isFinal && !this.invoice.finalizationStatus)
      return (
        <Button
          disabled={this.invoice?.isFinal || this.props.calcWork || this.props.workViesCheck}
          onClick={this.onViesCheck.bind(this)}
        >
          {this.lbl('invoice.details.updateAndfinalizeBtn')}
        </Button>
      );

    const status = getFinalizationStatus(this.props.invoice);
    if (FINALIZATION_STATUSES.READY_TO_INITIATE === status)
      return <Button onClick={() => finalize()}>{this.lbl('invoice.details.updateAndfinalizeBtn')}</Button>;

    if (FINALIZATION_STATUSES.DONE === status)
      return (
        <Button disabled={true} onClick={() => finalize()}>
          {this.lbl('invoice.details.updateAndfinalizeBtn')}
        </Button>
      );

    if (FINALIZATION_STATUSES.IN_PROGRESS === status)
      return (
        <Button disabled={true} onClick={() => finalize()}>
          {this.lbl('invoice.details.updateAndfinalizeBtn')}
        </Button>
      );

    if (FINALIZATION_STATUSES.ERROR === status)
      return (
        <Button onClick={this.props.retryFinalizationV2.bind(this)}>{this.lbl('invoice.details.retryFinalizeV2Btn')}</Button>
      );

    return '';
  }

  showDeleteModal = () => {
    this.setState({ showDeleteModal: true });
  };

  sendCreditRequest = properties => {
    this.setState(
      { showQuizCredit: false },

      this.props.createCreditInvoice(properties, result => {
        if (typeof result === 'number' && this.state.copyAfterCredit) {
          this.setState({ showCopyInvoiceModal: true });
          return;
        }
        if (typeof result === 'number') {
          this.to(`/invoices/incoming/${result}`);
        }
      }),
    );
  };

  onCancelQuiz = () => {
    this.setState({ showQuizCredit: false, showQuizDelete: false, copyAfterCredit: false });
  };

  sendDeleteRequest = properties => {
    const vehicleId = this.invoice?.vehicle?.id;
    this.setState({ showQuizDelete: false }, this.props.deleteInvoice(properties, this.redirectAfterDelete, vehicleId, this.forceDelete));
  };

  calculateFinAmounts() {
    if (!this.props.values['financial_purchase_price_excl_vat_excl_bpm']) {
      this.props.setValue('', 'financial_purchase_price_incl_vat_excl_bpm');
    }
    let financeField = '';
    if (
      (this.props.values?.btwOrMarge === VEHICLE_TAX_TYPE.BTW &&
        this.props.values?.vehiclePurpose == VEHICLE_PURPOSE.Commercial) ||
      (this.props.values?.btwOrMarge === VEHICLE_TAX_TYPE.BTW &&
        this.props.values?.vehiclePurpose == VEHICLE_PURPOSE.Passenger &&
        this.props.values?.import === '1')
    ) {
      financeField = 'financial_purchase_price_excl_vat_excl_bpm';
    }

    if (
      this.props.values?.btwOrMarge === VEHICLE_TAX_TYPE.BTW &&
      this.props.values?.vehiclePurpose == VEHICLE_PURPOSE.Passenger &&
      this.props.values?.import === '0'
    ) {
      financeField = 'financial_purchase_price_incl_vat_bpm';
    }

    if (
      this.props.values?.btwOrMarge === VEHICLE_TAX_TYPE.Marge &&
      this.props.values?.vehiclePurpose == VEHICLE_PURPOSE.Passenger
    ) {
      financeField = 'financial_purchase_price_marge_bpm';
    }

    if (
      this.props.values?.btwOrMarge === VEHICLE_TAX_TYPE.Marge &&
      this.props.values?.vehiclePurpose == VEHICLE_PURPOSE.Commercial
    ) {
      financeField = 'financial_purchase_price_marge_excl_bpm';
    }

    if (
      this.props.values?.btwOrMarge === VEHICLE_TAX_TYPE.Marge &&
      this.props.values?.vehiclePurpose == VEHICLE_PURPOSE.Passenger &&
      this.props.values?.import === '1'
    ) {
      financeField = 'financial_purchase_price_marge_excl_bpm';
    }

    const dto = {
      source: this.props.invoice.incomingCompany.company_from_eu,
      btwOrMarge: this.props.values?.btwOrMarge,
      vehiclePurpose: this.props.values?.vehiclePurpose,
      isImported: this.props.values?.import === '1',
      buyerType: this.props.invoice.incomingCompany.company_type,
      rest_bpm: +this.props.values?.rest_bpm ? fixPriceFormat(+this.props.values?.rest_bpm) : fixPriceFormat(0),
      dateFirstAllowance: this.props.values.date_first_allowance ?? null,
      // financial_bpm_gross: +this.props.values?.financial_bpm_gross || 0,
    };

    if (financeField) dto[financeField] = +this.props.values[financeField] || 0;
    this.props.calculatePurchasePrices(dto, result => {
      if (Object.keys(result)?.length) {
        Object.keys(result)?.map(price => {
          if ((price === 'outgoing_rest_bpm' || price === 'rest_bpm') && !result[price]) {
            return;
          }
          if (result[price] == 0) {
            if (price === 'rest_bpm') {
              return this.props.setValue(fixPriceFormat(result[price]), price);
            }
            return this.props.setValue('', price);
          }

          return this.props.setValue(result[price], price);
        });
      }
    });
  }

  render() {
    if (
      this.props.work ||
      this.props.workExport ||
      this.props.workFinalizeAndExport ||
      this.props.workAuthStatus ||
      this.props.workDecline ||
      this.props.workSyncBPM ||
      this.props.workCredit ||
      this.props.workEdit ||
      !this.props.invoice
    ) {
      return (
        <>
          <PageHeader
            title={
              <div className="pointer" onClick={this.tofn(`/invoices`)}>
                <Left />
                {this.lbl('vehicle.details.invoices.title')}
              </div>
            }
          />
          <LoadingDetailsPage />
        </>
      );
    }

    if (this.props.workDelete) {
      return <LoadingWithNotification message={this.lbl('invoice.details.delete_order_notification')} />;
    }
    if (parseInt(this.props?.invoice_id) !== this.props?.invoice?.id && this.props?.invoice?.id) {
      this.props.fetchInvoice();
    }

    const isDisabled = this.props.values.isAvailable === false;

    return (
      <>
        <PageHeader
          title={
            <div className="pointer" onClick={this.goBack}>
              <Left />
              {this.lbl('vehicle.details.invoices.title')}
            </div>
          }
        />
        <Container>
          <div className="column">
            <VBox left className="col" top>
              {this.state.showViesCheckPrompt && (
                <ViesCheckPrompt onConfirm={this.finalize.bind(this)} onCancel={this.reset.bind(this)} />
              )}
              {this.renderDeleteModal()}
              {!!this.state.showQuizCredit && (
                <InvoiceQuizModal
                  direction={this.invoice.direction}
                  vehicle={this.vehicleSubject[0]?.vehicle}
                  onConfirm={this.sendCreditRequest}
                  onCancel={this.onCancelQuiz}
                />
              )}
              {!!this.state.showQuizDelete && (
                <InvoiceQuizModal
                  direction={this.invoice.direction}
                  vehicle={this.vehicleSubject[0]?.vehicle}
                  onConfirm={this.sendDeleteRequest}
                  onCancel={this.onCancelQuiz}
                />
              )}
              <VehicleInvoiceCard
                isRequire={this.state.requireField}
                types={VEHICLE_PROPS}
                vehicle={this.invoice?.vehicle}
                calculateFinAmounts={this.calculateFinAmounts.bind(this)}
              />
              {this.renderCreditModal()}
              {this.renderCreditLimitWarningModal()}
              <CreditorInfoCard
                lastViesChecking={this.state.lastViesChecking}
                isRequire={this.state.requireField}
                types={BUYING_COMPANY_PROPS}
                vehicle={this.invoice?.vehicle}
                invoice={this.invoice}
              />
              <Permission permission={INVOICE_EDIT}>
                <Card className="vehicle-info-card info-card info">
                  <Button
                    primary
                    disabled={this.props.calcWork || !!this.props.invoice.finalizationStatus || isDisabled}
                    onClick={this.onUpdate.bind(this)}
                  >
                    {this.lbl('invoice.details.updateBtn')}
                  </Button>
                  {this.renderFinalizeBtn()}
                  {this.state.showPrompt && (
                    <List>
                      {this.state.showNonTotalAmountNotification && !+this.props.values?.financialTotalAmount && (
                        <Row key={'financialTotalAmount'}>
                          <Cell>
                            {this.lbl(`invoice.details.financialTotalAmount`)}
                            <RequireMark>*</RequireMark>
                          </Cell>
                        </Row>
                      )}
                      {this.state.requireField.map(field => {
                        if (!this.props.values[field]) {
                          return (
                            <Row key={field}>
                              <Cell>
                                {this.lbl(`invoice.details.${field}`)}
                                <RequireMark>*</RequireMark>
                              </Cell>
                            </Row>
                          );
                        }
                        return;
                      })}
                    </List>
                  )}
                  {this.exportedAtMsg}
                  <Button
                    {...(this.invoice?.isFinal ? { className: 'disabled' } : {})}
                    onClick={(e) => { if (!this.invoice?.isFinal || e.shiftKey) { this.forceDelete = e.shiftKey; this.showDeleteModal(); } }}
                    warning
                  >
                    {this.lbl('invoice.details.deleteOrderBtn')}
                  </Button>
                  <Button
                    disabled={
                      this.invoice?.type !== INVOICE_TYPES.INVOICE ||
                      !this.invoice?.exportedAt ||
                      this.invoice?.creditInvoiceId
                    }
                    onClick={this.showCreditModal}
                    warning
                  >
                    {this.lbl('invoice.details.creditBtn')}
                  </Button>
                  <Button
                    disabled={
                      this.invoice?.type !== INVOICE_TYPES.INVOICE ||
                      !this.invoice?.exportedAt ||
                      this.invoice?.creditInvoiceId
                    }
                    onClick={this.showCreditAndCopyModal}
                    warning
                  >
                    {this.lbl('invoice.details.creditAndCopyBtn')}
                  </Button>
                  {this.state.showCopyInvoiceModal && (
                    <Modal onClose={this.setStateFn({ showCopyInvoiceModal: false })}>
                      <InvoiceCreateCopyModals copyFromInvoiceId={this.invoice?.id} vehicleId={this.invoice?.vehicleId} />
                    </Modal>
                  )}
                </Card>
              </Permission>
              <CompanyDocumentsCard isInvoice={true} company={this.invoice?.incomingCompany} />
            </VBox>
          </div>
          <div className="column">
            <VBox left top>
              <Permission permission={PURCHASING_DATA_CRUD}>
                <InvoicePurchaseInfoCard
                  isRequire={this.state.requireField}
                  types={PURCHASE_PROPS}
                  secondaryTypes={this.getColumnTypes.bind(this)}
                  vehicle={this.invoice?.vehicle}
                  invoice={this.invoice}
                  extraTotalAmount={this.extraTotalAmount}
                  vehicleSubjectPrice={this.vehicleSubjectPrice}
                />
              </Permission>
              <Permission permission={VEHICLE_EXTRA_COSTS_CRUD}>
                <InvoiceSubjectsCard
                  onSave={this.onUpdate.bind(this)}
                  direction={this.invoice?.direction}
                  vehicle={this.invoice?.vehicle}
                  invoice={this.invoice}
                />
              </Permission>
            </VBox>
          </div>
          <div className="column">
            <VBox left top>
              <VehicleDocumentCard vehicleId={this.invoice?.vehicle?.id} />
              <div style={{ width: '100%' }}>
                <Card className="vehicle-info-card info-card info wide">
                  <PdfViewerCard vehicleId={this.invoice?.vehicle?.id} />
                </Card>
              </div>
              <div style={{ width: '100%' }}>
                <Card className="vehicle-info-card info-card info wide">
                  <LedgersPosting
                    smallTable={true}
                    invoice={this.invoice}
                    ledgersEntry={this.invoice.ledgersEntry}
                  ></LedgersPosting>
                </Card>
              </div>
            </VBox>
          </div>
        </Container>
      </>
    );
  }
}

IncomingInvoiceDetailsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    values: selectNewInvoice(),
    invoice: selectInvoice(),
    syncedBpm: selectAutotelexBPM(),
    work: selectWorks([REQUEST_INVOICE, REQUEST_EXACT_AUTH_STATUS]),
    workAuthStatus: selectWork(REQUEST_EXACT_AUTH_STATUS),
    workExport: selectWork(REQUEST_EXACT_EXPORT_INVOICE),
    workFinalizeAndExport: selectWork(FINALIZE_EXPORT_MAIL_INVOICE),
    workDecline: selectWork(REQUEST_INVOICE_DECLINE),
    workDelete: selectWork(REQUEST_INVOICE_DELETE),
    workSyncBPM: selectWork(REQUEST_SYNC_BPM),
    workCredit: selectWork(REQUEST_CREATE_CREDIT_INVOICE),
    workEdit: selectWork(REQUEST_UPDATE_INVOICE_V2),
    workViesCheck: selectWork(REQUEST_VIES_CHECK),
    workCompany: selectWork(REQUEST_COMPANY),
    calcWork: selectWorks([
      CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM,
      CALCULATE_PURCHASE_PRICES_MARGE,
      CALCULATE_PURCHASE_PRICES_BTW,
    ]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    finalizeAndExport(direction, email_address, callback) {
      dispatch(finalizeAndExportInvoice(ownProps.invoice_id, direction, email_address, callback));
    },
    checkViesStatus(dto, callback) {
      dispatch(checkVies(dto, callback));
    },
    getCode() {
      dispatch(getVatCodes());
    },
    init(id) {
      dispatch(initiateInvoiceEdit(id));
    },
    initiateValues(values) {
      values.map(type => dispatch(initiateNewInvoiceValue(type)));
    },
    update(dto, callback) {
      dispatch(updateInvoiceV2(ownProps.invoice_id, dto, callback));
    },
    fetchInvoice() {
      dispatch(fetchInvoice(ownProps.invoice_id));
    },
    fetchCompany(companyId) {
      dispatch(fetchCompany(companyId));
    },
    addRelationSource(data, callback) {
      const sanitizedData = { ...data, id: undefined };
      dispatch(addRelationSource(sanitizedData, ownProps.invoice_id, callback));
    },
    removeRelationSource(sourceId, callback) {
      dispatch(removeRelationSource(sourceId, ownProps.invoice_id, callback));
    },
    removeInvoiceSubject(subjectId, callback) {
      dispatch(removeInvoiceSubject(subjectId, ownProps.invoice_id));
    },
    exportInvoiceToExact() {
      dispatch(exportInvoiceToExact(ownProps.invoice_id));
    },
    getExactAuthStatus(callback) {
      dispatch(getExactAuthStatus(callback));
    },
    addInvoiceSubject(subject) {
      dispatch(addInvoiceSubject(subject, ownProps.invoice_id));
    },
    updateInvoiceSubject(subject, subjectId) {
      dispatch(updateInvoiceSubject(subject, ownProps.invoice_id, subjectId));
    },
    updateInvoiceStatus(statusId, callback) {
      dispatch(updateInvoiceStatus(ownProps.invoice_id, statusId, callback));
    },
    showError(error) {
      dispatch(addApiError(error));
    },
    declineInvoice() {
      dispatch(declineInvoice(ownProps.invoice_id));
    },
    deleteInvoice(properties, callback, vehicleId, force) {
      dispatch(deleteInvoice(ownProps.invoice_id, callback, properties, vehicleId, force));
    },
    createCreditInvoice(properties, callback) {
      dispatch(createCreditInvoice(ownProps.invoice_id, properties, callback));
    },
    getCurrentRestBpm(vehicleId) {
      dispatch(getCurrentRestBpm(vehicleId));
    },
    updateRestBpm(vehicleId, props) {
      dispatch(setVehicleProperties(vehicleId, props));
    },
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewInvoiceValue(name, value));
    },
    finalizeV2(dto, callback) {
      if (!dto) dto = {};
      dispatch(finalizeV2(ownProps.invoice_id, dto, callback));
    },
    retryFinalizationV2() {
      dispatch(retryFinalizationV2(ownProps.invoice_id));
    },
    calculatePurchasePrices(enteredAmounts, callback) {
      dispatch(calculatePurchasePriceInclVatExclBPM(enteredAmounts, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const IncomingInvoiceDetails = compose(withConnect, withRouter)(IncomingInvoiceDetailsComp);
